import axios from "axios";

import { BASEURL, BASEURLSUPORTE,BASEURLLOCAL } from "../helpers/constantes";
import { getToken, removeToken } from "./managerToken";
import Toastify from "../components/Toastify";

const api = axios.create({
    baseURL: `${BASEURL}api/`,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Expose-Headers": "Access-Control-*",
        "Access-Control-Allow-Headers":
            "Access-Control-*, Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS, HEAD",
        "Access-Control-Allow-Origin": "*",
    },
});

api.interceptors.request.use(
    async function (config) {
        // Do something before request is sent

        const AUTH_TOKEN = getToken();
        config.headers.Authorization = `Bearer ${AUTH_TOKEN}`;

        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    async function (config) {
        return config;
    },
    function (error) {
        // Do something with request error
        if (error.response) {
            if (error.response.status == 401) {
                if (!error.response.config.url == "security/validateuser") {
                    Toastify.error(
                        "Seu token expirou, faça o login novamente."
                    );
                }
                removeToken();
            } else if (error.response.status == 400) {
                if (error.response.data.Message) {
                    Toastify.error(error.response.data.Message);
                }
            } else {
                Toastify.error("😲 ocorreu um erro na sua solicitação");
            }
        } else {
            Toastify.error(
                `😲 ocorreu um erro na sua solicitação - ${error.message}`
            );
        }
        return Promise.reject(error);
    }
);

export default api;

export const apiRaw = axios.create({
    baseURL: `${BASEURL}api/`,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Expose-Headers": "Access-Control-*",
        "Access-Control-Allow-Headers":
            "Access-Control-*, Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS, HEAD",
        "Access-Control-Allow-Origin": "*",
    },
});
export const apiSuporte = axios.create({
    baseURL: `${BASEURLSUPORTE}api/`,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Expose-Headers": "Access-Control-*",
        "Access-Control-Allow-Headers":
            "Access-Control-*, Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS, HEAD",
        "Access-Control-Allow-Origin": "*",
    },
});
export const apiLocal = axios.create({
    baseURL: `${BASEURLLOCAL}api/`,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Expose-Headers": "Access-Control-*",
        "Access-Control-Allow-Headers":
            "Access-Control-*, Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS, HEAD",
        "Access-Control-Allow-Origin": "*",
    },
});
apiSuporte.interceptors.request.use(
    async function (config) {
        // Do something before request is sent

        const AUTH_TOKEN = getToken();
        config.headers.Authorization = `Bearer 0123456789`;

        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);
